import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_chanpinfangangaozhihaocaigui from '../views/lanhu_chanpinfangangaozhihaocaigui/index.vue'
import lanhu_chanpinfanganzhuanyunchuang from '../views/lanhu_chanpinfanganzhuanyunchuang/index.vue'
import lanhu_guanyuhuian from '../views/lanhu_guanyuhuian/index.vue'
import lanhu_xinwendongtai from '../views/lanhu_xinwendongtai/index.vue'
import lanhu_chanpinfanganguoyanghuaqingxiaoduji from '../views/lanhu_chanpinfanganguoyanghuaqingxiaoduji/index.vue'
import lanhu_chanpinfanganmajingyaopinche from '../views/lanhu_chanpinfanganmajingyaopinche/index.vue'
import lanhu_anlizhanshi from '../views/lanhu_anlizhanshi/index.vue'
import lanhu_xinwenxiangqing from '../views/lanhu_xinwenxiangqing/index.vue'
import lanhu_chanpinfanganaizhinenghuishouxiang from '../views/lanhu_chanpinfanganaizhinenghuishouxiang/index.vue'
import lanhu_chanpinfangandisandaimajingyaopinche from '../views/lanhu_chanpinfangandisandaimajingyaopinche/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/PageIndex"
  },
  {
    path: '/consumables_cabinet',
    name: 'consumables_cabinet',
    component: lanhu_chanpinfangangaozhihaocaigui
  },
  {
    path: '/transfer_bed',
    name: 'transfer_bed',
    component: lanhu_chanpinfanganzhuanyunchuang
  },
  {
    path: '/guanyuhuian',
    name: 'guanyuhuian',
    component: lanhu_guanyuhuian
  },
  {
    path: '/news_information',
    name: 'news_information',
    component: lanhu_xinwendongtai
  },
  {
    path: '/hydrogenperoxide_disinfection_machine',
    name: 'hydrogenperoxide_disinfection_machine',
    component: lanhu_chanpinfanganguoyanghuaqingxiaoduji
  },
  {
    path: '/two_narcotic_drug_vehicle',
    name: 'two_narcotic_drug_vehicle',
    component: lanhu_chanpinfanganmajingyaopinche
  },
  {
    path: '/case_presentation',
    name: 'case_presentation',
    component: lanhu_anlizhanshi
  },
  {
    path: '/lanhu_xinwenxiangqing',
    name: 'lanhu_xinwenxiangqing',
    component: lanhu_xinwenxiangqing
  },
  {
    path: '/ai_recycling_bin',
    name: 'ai_recycling_bin',
    component: lanhu_chanpinfanganaizhinenghuishouxiang
  },
  {
    path: '/three_narcotic_drug_vehicle',
    name: 'three_narcotic_drug_vehicle',
    component: lanhu_chanpinfangandisandaimajingyaopinche
  },
  {
    path: '/PageIndex',
    name: 'PageIndex',
    component: lanhu_shouye
  }
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const router = new VueRouter({
  mode: 'hash', // 改为 hash 模式适配本地文件
  routes
})

export default router
